import { render, staticRenderFns } from "./applets.vue?vue&type=template&id=47e0b83b&"
import script from "./applets.vue?vue&type=script&lang=js&"
export * from "./applets.vue?vue&type=script&lang=js&"
import style0 from "./applets.vue?vue&type=style&index=0&id=47e0b83b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports